// Results' sticky segment bar (spec §3): presets as shortcuts that write the
// time chip, kore's filter row for the rest, and a link to the same
// segment's responses. Presentational: ResultsPage owns the search.

import { SearchBar, type UseKoreSearchResult } from "@pej/kore/components";
import type { ReactElement, Ref } from "react";
import type { Preset } from "@/features/time/time-chip";
import { TimePresets } from "@/features/time/time-presets";
import type { RawFilters } from "./responses-filters";

export interface SegmentBarProps {
    barProps: UseKoreSearchResult<RawFilters>["barProps"];
    selected: Preset | null;
    /** = onSearchPatch(presetPatch(preset)): the raw page patch, never through timePatch. */
    onPreset: (preset: Preset) => void;
    responsesLink: ReactElement;
    /** The bar, measured by the page for its sections' scroll margin. */
    ref?: Ref<HTMLFieldSetElement>;
}

export function SegmentBar({ barProps, selected, onPreset, responsesLink, ref }: SegmentBarProps) {
    return (
        // Sticky with the page (spec §2): the segment drives every section.
        // Opaque, so the sections scrolling under it don't show through.
        <fieldset
            ref={ref}
            aria-label="Segment"
            className="sticky top-6 z-20 -my-3 flex min-w-0 flex-wrap items-start gap-3 bg-background py-3"
        >
            <TimePresets selected={selected} onPreset={onPreset} />
            {/* At least 20rem: on a narrow column the filters wrap below the
                presets rather than squeeze kore's chips out of their panel. */}
            <div className="min-w-0 flex-1 basis-80">
                <SearchBar {...barProps} size="compact" />
            </div>
            {responsesLink}
        </fieldset>
    );
}
